import AutoScroll from '@components/AutoScroll'

import MessageForm from './MessageForm'

const Conversation = ({
  children,
  sendMessage,
  uploadAttachments,
  isUploading,
  transcribeAudio,
  isTranscribing,
  noticeMessage = "AI responses aren't always factually accurate.",
  chatEnabled = true,
  ChatDisabledComponent,
  className
}) => {
  return (
    <div className={`h-full w-full overflow-auto bg-background relative flex flex-col ${className || ''}`}>
      <div className='absolute top-0 right-0 left-0 h-10 z-10 bg-linear-to-b from-background to-transparent pointer-events-none' />

      {/* Height is 100% minus message input */}
      <AutoScroll className='h-[calc(100%-60px)] flex flex-col overflow-scroll pt-10 md:p-5 px-3'>
        {children}
      </AutoScroll>

      <Choose>
        <When condition={chatEnabled}>
          <MessageForm
            sendMessage={sendMessage}
            uploadAttachments={uploadAttachments}
            isUploading={isUploading}
            noticeMessage={noticeMessage}
            mathsInputEnabled
            visionEnabled
            transcribeAudio={transcribeAudio}
            isTranscribing={isTranscribing}
          />
        </When>

        <Otherwise>
          <ChatDisabledComponent />
        </Otherwise>
      </Choose>
    </div>
  )
}

export default Conversation
